
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "../src/styles/global.css";
import TopBar from "./components/layout/Topbar";
import Header from "./components/layout/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Branches from "./pages/Branches";
import Equipment from "./pages/Equipment";
import Beans from "./pages/Beans";
import Contact from "./pages/Contact";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminProducts from "./pages/admin/AdminProducts";
import BranchesSection from "./pages/admin/BranchesSection";

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && (
        <>
          <TopBar />
          <Header />
        </>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/subeler" element={<Branches />} />
        <Route path="/ekipman" element={<Equipment />} />
        <Route path="/cekirdekler" element={<Beans />} />
        <Route path="/iletisim" element={<Contact />} />

        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/products" element={<AdminProducts />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}